import { useRef } from 'react'
import { MessageSquare, Plus } from 'lucide-react'
import Communication from '../UI/Communication'
import SectionBlock from '../UI/SectionBlock'
import SectionHeader from '../UI/SectionHeader'

const CommunicationsSection = ({ talentId, talentType, hasPermission }) => {
  const commRef = useRef(null)

  return (
    <SectionBlock id="communications">
      <SectionHeader
        icon={MessageSquare}
        title="Communications"
        action={hasPermission('talent-service', `${talentType}_communication`, 'create') ? (
          <button
            onClick={() => commRef.current?.openForm()}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white text-xs font-medium rounded-lg hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 transition-colors"
          >
            <Plus className="h-3.5 w-3.5" />Add
          </button>
        ) : null}
      />
      <Communication ref={commRef} entityId={talentId} entityType="talent" talentType={talentType} showAddButton={false} />
    </SectionBlock>
  )
}

export default CommunicationsSection
